import { __decorate as t, __classPrivateFieldGet as e, __classPrivateFieldSet as i } from "tslib";
import { LitElement as s, html as n } from "lit";
import { property as o, state as r } from "lit/decorators.js";
import l from "../../../styles/global-styles.js";
import { stylesBase as a, styles1177pro as d, stylesInera as c, stylesIneraAdmin as p, stylesIneraLegacy as h, stylesIneraAdminLegacy as u } from "./navigation-item-styles.js";
import { generateId as f } from "../../../../utilities/utils.js";
var m, y, v, k, g, x, b, $, w;
class E extends s {
  constructor() {
    super(...arguments), m.set(this, ""), y.set(this, void 0), v.set(this, !1), k.set(this, !1), g.set(this, !1), x.set(this, !1), b.set(this, !1), $.set(this, !1), w.set(this, 0), this.contentId = f(), this.detectClickOutside = t => {
      this.contains(t.target) || (this.isExpanded = !1);
    };
  }
  get label() {
    return e(this, m, "f");
  }
  set label(t) {
    i(this, m, t, "f");
  }
  get type() {
    return e(this, y, "f");
  }
  set type(t) {
    i(this, y, t, "f");
  }
  get link() {
    return e(this, v, "f");
  }
  set link(t) {
    i(this, v, t, "f");
  }
  get fluid() {
    return e(this, k, "f");
  }
  set fluid(t) {
    i(this, k, t, "f");
  }
  get active() {
    return e(this, g, "f");
  }
  set active(t) {
    i(this, g, t, "f");
  }
  get expanded() {
    return e(this, x, "f");
  }
  set expanded(t) {
    i(this, x, t, "f");
  }
  get unresponsive() {
    return e(this, b, "f");
  }
  set unresponsive(t) {
    i(this, b, t, "f");
  }
  get isExpanded() {
    return e(this, $, "f");
  }
  set isExpanded(t) {
    i(this, $, t, "f");
  }
  get notifications() {
    return e(this, w, "f");
  }
  set notifications(t) {
    i(this, w, t, "f");
  }
  get linkText() {
    return this.querySelector("a")?.textContent.trim();
  }
  disconnectedCallback() {
    document.removeEventListener("click", this.detectClickOutside), super.disconnectedCallback();
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.querySelectorAll("ids-link").forEach(t => {
      t.setAttribute("activeicon", "true"), "1177-pro" === this.type ? t.setAttribute("colorpreset", "1") : t.setAttribute("colorpreset", "2");
      const e = t.querySelector(".ids-icon");
      e?.setAttribute("width", "10px"), e?.setAttribute("height", "10px");
    }), this.isExpanded = this.expanded, document.addEventListener("click", this.detectClickOutside);
  }
  toggleActive() {
    this.isExpanded = !this.isExpanded;
  }
  renderContent() {
    return this.isExpanded ? n`<div id="${this.contentId}" class="header-nav-item-content"><ids-container ?fluid="${this.fluid}" gutterless><ids-row class="mega-menu-row"><ids-col cols="3"><slot name="col-1"></slot></ids-col><ids-col cols="3"><slot name="col-2"></slot></ids-col><ids-col cols="3"><slot name="col-3"></slot></ids-col><ids-col cols="3"><div class="nav-item-content"><slot name="col-4"></slot></div></ids-col></ids-row></ids-container></div>` : n``;
  }
  clickLink() {
    this.querySelector("a")?.click();
  }
  renderNavItem() {
    return this.link ? n`<span class="nav-item ${this.active ? "active" : ""}">${this.linkText} ${this.renderNotifications()}<slot></slot></span>` : n`<button aria-controls="${this.contentId}" aria-expanded="${this.isExpanded}" class="btn-no-styles nav-item ${this.isExpanded ? "expanded" : ""} ${this.active ? "active" : ""}" @click="${this.toggleActive}">${this.label} ${this.renderNotifications()}</button>`;
  }
  renderNotifications() {
    return this.notifications > 0 ? n`<ids-notification-badge>${this.notifications}</ids-notification-badge>` : n``;
  }
  render() {
    return n`${this.renderNavItem()} ${this.renderContent()}`;
  }
}
m = new WeakMap(), y = new WeakMap(), v = new WeakMap(), k = new WeakMap(), g = new WeakMap(), x = new WeakMap(), b = new WeakMap(), $ = new WeakMap(), w = new WeakMap(), E.styles = [l, a, d, c, p, h, u], t([o({
  type: String,
  reflect: !0
})], E.prototype, "label", null), t([o({
  type: String,
  reflect: !0
})], E.prototype, "type", null), t([o({
  type: Boolean
})], E.prototype, "link", null), t([o({
  type: Boolean
})], E.prototype, "fluid", null), t([o({
  type: Boolean
})], E.prototype, "active", null), t([o({
  type: Boolean
})], E.prototype, "expanded", null), t([o({
  type: Boolean,
  reflect: !0
})], E.prototype, "unresponsive", null), t([r()], E.prototype, "isExpanded", null), t([o({
  type: Number
})], E.prototype, "notifications", null);
export { E as IDSHeaderNavItem };